import React, { useState } from 'react';
import * as Yup from 'yup';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import Logo from '../../Assets/images/logo.png';
import Banner from '../../Assets/images/banner.jpg';
import { useNavigate } from 'react-router-dom';
import { forgotPassword } from '../../Services/Authentication.Serivice';
import Toaster from '../../Components/Toaster';

function ForgotPassword({ setIsLoggedIn }) {
  const navigate = useNavigate();
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastVariant, setToastVariant] = useState(''); // 'success' or 'error'
  const dirPath = process.env.REACT_APP_SUB_DIR;

  const handleLogin = () => {
    navigate("/login");
  };

  // Form validation schema
  const validationSchema = Yup.object({
    email: Yup.string()
      .matches(/^\S*$/, 'No spaces are allowed')
      .max(50, 'Email must not be more than 50 characters')
      .email('Invalid email address')
      // .matches(/^[^@\s]+@[^@\s]+\.[^@\s]+$/, 'Invalid email address')
      .matches(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, 'Invalid email address')
      .required('Email is required')
  });

  // Handle form submission
  const handleSubmit = async (values, { setSubmitting, setErrors, resetForm }) => {
    try {
      const response = await forgotPassword(values.email);
      
      if (response.status) {
        // Set success toast
        setToastMessage(response.message);
        setToastVariant('success');
        setShowToast(true);

      } else {
        // Set error toast
        setToastMessage(response.error);
        setToastVariant('error');
        setShowToast(true);
        setErrors({ email: 'Failed to send reset password email' });
      }
    } catch (error) {
      // Set error toast
      setToastMessage(error.response?.data?.error || 'An error occurred. Please try again later.');
      setToastVariant('error');
      setShowToast(true);
    }
    setSubmitting(false);
    resetForm()
  };

  return (
    <>
      <main className="d-flex align-items-center bg-white" style={{ background: `url(${Banner}) left center no-repeat`, backgroundSize: 'cover' }}>
        <section className="el-login-sec w-100">
          <div className="ml-auto d-block">
            <div className="el-login-background d-block box-shadow-none">
              <div className="el-login-card ml-lg-auto d-block">
                <div className="el-login-logo">
                  <img src={Logo} className="img-fluid logindonar-x-logo" alt="donorx" />
                </div>

                <h2>Forgot Password</h2>

                <Formik
                  initialValues={{ email: '' }}
                  validationSchema={validationSchema}
                  validateOnBlur={false}
                  validateOnChange={true}
                  onSubmit={handleSubmit}
                >
                  {({ isSubmitting }) => (
                    <Form className="el-login-form">
                      <div className="el-form-group mb-3">
                        <label htmlFor="email" className="form-label">Enter your Email<span className="text-red">*</span></label>
                        <Field
                          type="email"
                          name="email"
                          placeholder="Email"
                          className="form-control"
                          id="email"
                        />
                        <ErrorMessage name="email" component="div" className="text-danger" />
                      </div>

                      <div className="el-form-btn-submit">
                        <button type="submit" className="el-btn-primary" disabled={isSubmitting}>
                          {isSubmitting ? 'Submitting...' : 'Submit'}
                        </button>
                      </div>

                      <div className="el-form-link text-center">
                        <a onClick={handleLogin} className="elfotget-password">Back to Login</a>
                      </div>
                    </Form>
                  )}
                </Formik>

              </div>
            </div>
          </div>
        </section>
      </main>

      {/* Reusable Toaster */}
      <Toaster
        show={showToast}
        message={toastMessage}
        variant={toastVariant}
        onClose={() => setShowToast(false)}
      />
    </>
  );
}

export default ForgotPassword;
